export const CIVILBUDGETCONTROL_LOADING = "CIVILBUDGETCONTROL_LOADING";
export const CIVILBUDGETCONTROL_RESET = "CIVILBUDGETCONTROL_RESET";
export const GET_CIVILBUDGETCONTROL = "GET_CIVILBUDGETCONTROL";
export const GET_CIVILBUDGETCONTROL_SUCCESS = "GET_CIVILBUDGETCONTROL_SUCCESS";
export const GET_CIVILBUDGETCONTROL_FAIL = "GET_CIVILBUDGETCONTROL_FAIL";
export const DELETE_CIVILBUDGETCONTROL = "DELETE_CIVILBUDGETCONTROL"
export const DELETE_CIVILBUDGETCONTROL_SUCCESS = "DELETE_CIVILBUDGETCONTROL_SUCCESS"
export const DELETE_CIVILBUDGETCONTROL_FAIL = "DELETE_CIVILBUDGETCONTROL_FAIL"
export const UPDATE_CIVILBUDGETCONTROL = "UPDATE_CIVILBUDGETCONTROL"
export const UPDATE_CIVILBUDGETCONTROL_SUCCESS = "UPDATE_CIVILBUDGETCONTROL_SUCCESS"
export const UPDATE_CIVILBUDGETCONTROL_FAIL = "UPDATE_CIVILBUDGETCONTROL_FAIL"
export const ADD_NEW_CIVILBUDGETCONTROL = "ADD_NEW_CIVILBUDGETCONTROL"
export const ADD_CIVILBUDGETCONTROL_SUCCESS = "ADD_CIVILBUDGETCONTROL_SUCCESS"
export const ADD_CIVILBUDGETCONTROL_FAIL = "ADD_CIVILBUDGETCONTROL_FAIL"